module.exports = __webpack_public_path__ + "static/media/imgFelipeFerraz.d8c89f91.png";